<template>
  <div class="tooltip-container">
    <mi-icon
      ref="icon"
      name="info-circle"
      size="11px"
      @mouseenter="handleMouseEnter"
      @focus="handleMouseEnter"
      @blur="showTooltip = false"
      @mouseleave="showTooltip = false"
    >
    </mi-icon>
    <div
      v-if="showTooltip"
      class="custom-tooltip"
      :style="tooltipStyle"
    >
      <div class="overview-tooltip-wrapper">
        <bom-validation-overview-status
          first-status="red"
          second-status="green"
          third-status="green"
        ></bom-validation-overview-status>
        <span class="text-body2 text-primary text-family-condensed">
          <b> Ambiguous </b> results
        </span>
      </div>
      <div class="overview-tooltip-wrapper">
        <bom-validation-overview-status
          first-status="green"
          second-status="red"
          third-status="green"
        ></bom-validation-overview-status>
        <span class="text-body2 text-primary text-family-condensed">
          <b> Incomplete </b> results
        </span>
      </div>
      <div class="overview-tooltip-wrapper">
        <bom-validation-overview-status
          first-status="green"
          second-status="green"
          third-status="red"
        ></bom-validation-overview-status>
        <span class="text-body2 text-primary text-family-condensed">
          <b> Unused </b> results
        </span>
      </div>
      <div class="overview-tooltip-wrapper">
        <bom-validation-overview-status
          first-status="green"
          second-status="green"
          third-status="green"
        ></bom-validation-overview-status>
        <span class="text-body2 text-primary text-family-condensed">
          <b> All good </b> results
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import { ref } from 'vue'
  import BomValidationOverviewStatus from '@/components/validations/bom/BomValidationOverviewStatus.vue'

  const TOOLTIP_LEFT_POSITION = 0
  const TOOLTIP_BOTTOM_POSITION = 10

  export default {
    name: 'BomValidationOverviewTooltip',
    components: { BomValidationOverviewStatus },
    setup() {
      const showTooltip = ref(false)
      const tooltipStyle = ref({})
      const icon = ref(null)

      const handleMouseEnter = () => {
        showTooltip.value = true

        const iconElement = icon.value?.$el || icon.value
        if (iconElement) {
          const rect = iconElement.getBoundingClientRect()
          tooltipStyle.value = {
            top: `${ rect.bottom + TOOLTIP_BOTTOM_POSITION }px`,
            left: `${ rect.left - TOOLTIP_LEFT_POSITION }px`,
            position: 'fixed'
          }
        }
      }

      return {
        showTooltip,
        tooltipStyle,
        icon,
        handleMouseEnter
      }
    }
  }
</script>

<style lang="scss" scoped>
  .overview-tooltip-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 20px;
  }

  .tooltip-container {
    position: relative;
    display: inline-block;
  }

  .custom-tooltip {
    display: flex;
    flex-direction: column;
    background-color: $mi-white;
    padding: 16px;
    border-radius: 4px;
    font-size: 14px;
    width: fit-content;
    z-index: 1;
    box-shadow: 0 5px 4px 0 #00000040;
  }
</style>
